module.exports = __webpack_public_path__ + "static/img/tips5.20533aa1.png";